// extracted by mini-css-extract-plugin
module.exports = {"dragScope":"dragScope__3NbF4","text":"text__2TZIy","count":"count__2UVkY"};